import { HiMenuAlt3, HiX } from "react-icons/hi";
import { menuItems, personalInformation } from "../helper/constant";

const Sidebar = ({ activeTab, onTabChange, isOpen, setIsOpen }) => {
  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden fixed top-6 right-6 z-[60] p-3 bg-brand-cream2 text-brand-dark rounded-full shadow-lg"
      >
        {isOpen ? <HiX size={24} /> : <HiMenuAlt3 size={24} />}
      </button>

      <aside
        className={`
        fixed inset-y-0 left-0 z-50 w-72 bg-brand-dark border-r border-neutral-800 transform transition-transform duration-300
        ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 lg:static
      `}
      >
        <div className="flex flex-col h-full p-8">
          <div className="mb-12">
            <h1 className="text-2xl font-bold text-brand-cream2 tracking-tighter">
              {personalInformation.name}
            </h1>
            <p className="text-brand-cream text-[10px] font-mono mt-1 uppercase tracking-widest opacity-70">
              {personalInformation.role}
            </p>
          </div>

          <nav className="flex-1 space-y-2">
            {menuItems.map((item) => {
              const isActive = activeTab === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => onTabChange(item.id)}
                  aria-current={isActive ? "page" : undefined}
                  className={`relative w-full flex items-center gap-4 pl-5 pr-5 py-3 rounded-xl text-sm transition-all duration-200 ${
                    isActive
                      ? "bg-brand-cream2 text-brand-dark font-bold shadow-lg"
                      : "text-brand-cream hover:bg-white/5 hover:translate-x-1"
                  }`}
                >
                  {isActive && (
                    <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-1 rounded-full bg-brand-dark" />
                  )}
                  <span
                    className={`text-base transition-transform ${
                      isActive ? "scale-110" : "group-hover:scale-110"
                    }`}
                  >
                    {item.icon}
                  </span>
                  {item.label}
                </button>
              );
            })}
          </nav>

          <div className="pt-6 border-t border-neutral-800">
            <div className="flex flex-col gap-1">
              <p className="text-[9px] text-neutral-500 uppercase tracking-[0.2em]">
                © {new Date().getFullYear()} {personalInformation.name}
              </p>
              <p className="text-[8px] text-neutral-600 uppercase tracking-[0.1em]">
                All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </aside>

      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"
        />
      )}
    </>
  );
};

export default Sidebar;
